(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire409a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire409a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dthk8", function(module, exports) {
// ==UserScript==
// @name GitHub Emoji on Linux
// @description Convinces GitHub that Linux supports emoji by removing Linux from the user-agent.
// @version 2
// @namespace https://userscripts.kevincox.ca
// @match https://github.com/*
// @run-at document-start
// @grant unsafeWindow
// ==/UserScript==
Object.defineProperty(unsafeWindow.navigator, "userAgent", {
    value: navigator.userAgent.replace("Linux", "LinMoji") + " (https://github.com/github/g-emoji-element/issues/2)"
});
// GitHub also tries to override our preferred emoji font, undo that.
document.head.insertAdjacentHTML("beforeend", `<style>g-emoji{font-family:initial!important}</style>`);

});


parcelRequire("dthk8");
})();
//# sourceMappingURL=github-emoji-linux.user.js.map
